<nav class="footer-navigation-ui">
  @for (childNode of node?.children; track childNode?.title) {
    <section class="footer-navigation-ui--category" [attr.aria-labelledby]="childNode.title">
      <div [id]="childNode.title" class="footer-navigation-ui--title">{{ childNode.title }}</div>
      <ul class="footer-navigation-ui--list">
        @for (child of childNode?.children; track child?.title) {
          <li class="footer-navigation-ui--item">
            @if (child.url) {
              <cx-generic-link
                [url]="child?.localizedUrl || child.url"
                [target]="child.target"
                [style]="child.styleAttributes"
                [class]="child.styleClasses"
                (click)="nodeClicked(node?.javaScript)">
                {{ child?.title }}
              </cx-generic-link>
            } @else {
              <span
                class="footer-navigation-ui--link"
                [attr.tabindex]="flyout && child.url ? 0 : -1"
                (click)="nodeClicked(child?.javaScript)"
                >{{ child.title }}</span
              >
            }
          </li>
        }
      </ul>
    </section>
  }
</nav>
